<template>
  <div>
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div
          class="flex flex-col-reverse lg:flex-row justify-between items-center gap-8 rounded-3xl shadow-xl my-10 h-full"
        >
          <div
            class="lg:px-20 flex flex-col py-10 gap-6 justify-between h-full text-center lg:text-left px-6"
          >
            <h1 class="font-bold lg lg:text-3xl prime" v-if="this.userInfo">
              Welcome
              <span v-if="this.userInfo.user.display_name">
                {{ this.userInfo.user.display_name }}
              </span>
              <span v-else>{{ this.userInfo.user.permission }}</span>
              <span class="text-[#105C8E] lg lg:text-3xl ml-2 lg:ml-5"></span>
            </h1>

            <div class="max-w-sm text-left">
              <h2 class="font-bold text-2xl lg:text-4xl text-[#1a2b6d] mb-4 leading-tight">
                Your Growth Journey <br/>
                <span class="text-blues">Continues Here</span>
              </h2>
              <p class="content text-lg">
                Access your learning resources, complete your assigned trainings, and build new skills — all in one place.
              </p>
            </div>

            <form @submit.prevent="searchUserValue" class="w-full hidden">
              <div
                class="flex flex-wrap md:flex-nowrap items-center justify-center lg:justify-start gap-4 relative"
              >
                <input
                  type="text"
                  v-model="searching"
                  @input="searchUserValue"
                  placeholder="Search ..."
                  class="rounded-full px-6 py-3 border w-full lg:w-auto"
                />
                <button
                  type="submit"
                  class="bg-primary py-3 rounded-2xl text-white px-6"
                >
                  Search
                </button>
              </div>
            </form>
            <SearchView />
          </div>

          <div class="flex justify-center lg:justify-end w-full lg:w-auto">
            <img
              src="@/assets/new/index.jpeg"
              alt=""
              class="w-full lg:w-auto h-auto rounded-r-3xl object-contain max-h-[400px]"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="py-3 pb-20">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 shadow-xl rounded-3xl p-4"
          style="box-shadow: 0px 2px 20px 0px #105c8e26"
        >
          <!-- calender -->
          <div class="flex flex-col md:min-w-[330px]">
            <!-- <h1 class="text-[#0F172A] text-lg font-semibold px-6 pt-6">Calendar</h1> -->
            <div class="flex flex-col gap-3 md:min-w-[330px]">
              <Calendar @addFilterEmit="receiveCalEmit" />
              <!-- <vue-cal
                small
                ref="vuecal"
                events-on-month-view="short"
                :disable-views="['years', 'year', 'week', 'day']"
                :events="values"
                :on-event-click="onEventClick"
                class=""
              >
              </vue-cal> -->
            </div>
          </div>

          <!-- todo -->
          <div class="flex flex-col gap-3 md:min-w-[330px]">
            <div v-if="submittedURL.length > 0" class="space-y-3">
              <div
                v-for="item in submittedURL"
                :key="item.id"
                class="relative bg-[#EDF8FF] py-3 px-4 rounded-xl"
              >
                <!-- Top-right icons -->
                <div class="absolute top-3 right-3 flex gap-3">
                  <button
                    @click="openEditModal(item)"
                    class="text-blue-600 hover:text-blue-800"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#2854C5"
                    >
                      <path
                        d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
                      />
                    </svg>
                  </button>

                  <button @click="confirmDelete(item.slug)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#EA3323"
                    >
                      <path
                        d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                      />
                    </svg>
                  </button>
                </div>

                <!-- Content -->
                <h2 class="text-[#0085DB] font-semibold pr-16">
                  {{ item.title }}
                </h2>

                <!-- Optional: remove this if you don't want URL visible -->
                <a
                  :href="item.urllink"
                  target="_blank"
                  class="text-sm text-blue-600 underline break-all"
                >
                  {{ item.urllink }}
                </a>
              </div>
            </div>

            <div
              v-else
              class="flex justify-between items-center bg-[#EDF8FF] py-2 px-3 rounded-xl"
            >
              <h1 class="text-[#0085DB] font-semibold">Submit Link</h1>

              <button
                @click="openPopup = true"
                class="bg-[#0085DB] text-white px-3 py-1 rounded-lg text-sm hover:bg-[#006bb3]"
              >
                + Add
              </button>
            </div>
            <!-- Delete Confirmation Popup -->
            <div
              v-if="showDeletePopup"
              class="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
            >
              <div
                class="bg-white rounded-2xl w-[90%] md:w-[400px] shadow-xl p-6"
              >
                <h2 class="text-lg font-semibold text-gray-800 mb-3">
                  Delete Confirmation
                </h2>

                <p class="text-gray-600 mb-6">
                  Are you sure you want to delete this link?
                </p>

                <div class="flex justify-end gap-4">
                  <button
                    @click="showDeletePopup = false"
                    class="px-4 py-2 rounded-lg border hover:bg-gray-100"
                  >
                    Cancel
                  </button>

                  <button
                    @click="deleteURL"
                    class="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>

            <!-- Edit Popup -->
            <div
              v-if="openEditPopupURL"
              class="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
            >
              <form
                @submit.prevent="updateURL"
                class="bg-white rounded-2xl w-[90%] md:w-[520px] shadow-xl"
              >
                <!-- Header -->
                <div
                  class="flex justify-between items-center px-6 py-4 border-b"
                >
                  <h2 class="text-lg font-semibold text-blue-600">Edit File</h2>

                  <button
                    @click="openEditPopupURL = false"
                    type="button"
                    class="text-red-500 hover:text-red-700 text-xl font-bold"
                  >
                    ✕
                  </button>
                </div>

                <!-- Body -->
                <div class="p-6 space-y-4">
                  <div>
                    <label class="block text-sm font-medium mb-1">
                      Title : <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="editTitle"
                      type="text"
                      required
                      class="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium mb-1">
                      Link : <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="editLink"
                      type="text"
                      required
                      class="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <!-- Footer -->
                <div class="flex justify-end px-6 py-4">
                  <button
                    type="submit"
                    class="bg-blues hover:bg-hover text-white px-6 py-2 rounded-lg"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
            <!-- Add File Popup -->
            <div
              v-if="openPopup"
              class="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
            >
              <form
                @submit.prevent="addURL"
                class="bg-white rounded-2xl w-[90%] md:w-[520px] shadow-xl"
              >
                <div
                  class="flex justify-between items-center px-6 py-4 border-b"
                >
                  <h2 class="text-lg font-semibold text-blue-600">Add URL</h2>

                  <button
                    @click="openPopup = false"
                    class="text-red-500 hover:text-red-700 text-xl font-bold"
                  >
                    ✕
                  </button>
                </div>

                <div class="p-6 space-y-4">
                  <div>
                    <label class="block text-sm font-medium mb-1">
                      Title <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="fileTitle"
                      type="text"
                      required
                      placeholder="Enter Title"
                      class="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium mb-1">
                      Link <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="fileLink"
                      type="text"
                      required
                      placeholder="Enter Link"
                      class="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div class="flex justify-end px-6 py-4">
                  <button
                    type="submit"
                    :disabled="disable_submit"
                    class="bg-blues hover:bg-hover text-white px-6 py-2 rounded-lg"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>

            <div v-if="submitted.length > 0">
              <div v-for="(item, index) in submitted" :key="index" class="pb-3">
                <div
                  class="flex justify-between items-center bg-sky-50 hover:bg-sky-100 border border-sky-100 p-3 rounded-2xl transition duration-200 ease-in-out"
                >
                  <h1
                    class="text-sky-700 text-sm md:text-base font-medium leading-snug w-[90%]"
                  >
                    {{ item.title }}
                  </h1>
                  <a :href="item.pdf" download target="_blank">
                    <svg
                      class="cursor-pointer w-6 h-6 fill-sky-600 hover:fill-sky-800 transition duration-200"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 -960 960 960"
                    >
                      <path
                        d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"
                      />
                    </svg>
                  </a>
                </div>

                <p
                  class="truncate w-full flex items-center justify-between bg-gray-100 p-2 rounded mt-2 hidden"
                >
                  {{ getShortName(item.pdf) }}
                </p>
              </div>
              <!-- <div>
                <div
                  class="flex items-center justify-between w-full bg-gray-100 p-2 rounded mt-2"
                >
                  
                </div>
              </div> -->
            </div>
            <div
              class="bg-[#EDF8FF] flex justify-between py-2 px-3 rounded-xl items-center"
            >
              <h1 class="text-[#0085DB] lg font-semibold">Tasks for Today</h1>
              <router-link :to="{ name: 'AdminMyTask' }">
                <img
                  src="@/assets/chevron-down.png"
                  alt=""
                  srcset=""
                  class="object-contain w-5 h-5"
                />
              </router-link>
            </div>
            <div class="flex flex-col gap-2 justify-start p-6 h-[330px]">
              <form @submit.prevent="addTask">
                <div class="flex flex-col gap-2">
                  <p
                    v-if="success_message"
                    class="text-xs text-green-400 font-bold"
                  >
                    {{ success_message }}
                  </p>
                  <p
                    v-if="success_delemessage"
                    class="text-xs text-red-400 font-bold"
                  >
                    {{ success_delemessage }}
                  </p>

                  <div class="">
                    <input
                      v-model="newTask"
                      type="text"
                      class="border-b outline-none flex-1 p-1 w-full"
                      placeholder="+Add New Task"
                      @input="showButton = newTask.length > 0"
                      @keyup.enter="addTask"
                    />
                  </div>
                  <div
                    v-show="showButton"
                    class="flex justify-end items-center"
                  >
                    <div class="flex gap-1">
                      <div class="flex justify-end items-center gap-3">
                        <button
                          type="submit"
                          :disabled="disable_submit == true"
                          class="text-white rounded transition-opacity cursor-pointer"
                        >
                          <!-- ✅ -->
                          <img
                            src="@/assets/newd/Vector(1).svg"
                            alt=""
                            srcset=""
                            class="w-5 h-5 bg-[#EBEBEB] p-1"
                          />
                        </button>
                        <img
                          v-if="disable_submit"
                          src="@/assets/loading.gif"
                          alt="loading"
                          class="w-6 h-6 object-contain"
                        />
                      </div>
                      <!-- <button
                        class="text-white rounded transition-opacity cursor-pointer"
                      >
                        
                        <img
                          src="@/assets/newd/Vector(1).svg"
                          alt=""
                          srcset=""
                          class="w-5 h-5 bg-[#EBEBEB] p-1"
                        />
                      </button> -->
                      <div @click="cleartask" class="cursor-pointer">
                        <img
                          src="@/assets/newd/closebutton.svg"
                          alt=""
                          class="w-6 h-6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <ul class="overflow-y-auto" v-if="todolist.length > 0">
                <li v-for="task in todolist" :key="task.id" class="group py-2">
                  <div
                    class="flex justify-between bg-[#F4F4F4] w-full p-2 rounded-md"
                    v-if="task.completed == false"
                  >
                    <p class="text-sm break-words w-[230px] line-clamp-2">
                      {{ task.text }}
                    </p>
                    <div
                      class="flex gap-2 w-[25%] opacity-100 xl:opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    >
                      <!-- <button @click="completeTask(task.id)" class="">✅</button> -->
                      <button @click="completeTask(task.id)" class="">
                        <img
                          src="@/assets/newd/Vector(1).svg"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EBEBEB] p-1"
                        />
                      </button>

                      <button @click="openEditPopup(task)" class="">
                        <img
                          src="@/assets/newd/Group.svg"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EBEBEB] p-1"
                        />
                      </button>
                      <button @click="deleteTask(task.id)" class="">
                        <img
                          src="@/assets/newd/Vector.svg"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EBEBEB] p-1"
                        />
                      </button>
                    </div>
                  </div>
                </li>
              </ul>

              <div v-else class="text-center">No task</div>
              <!-- Edit Popup -->
              <!-- <div
                v-if="isEditing"
                class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
              >
                <div class="bg-white p-4 rounded shadow-lg">
                  <h3 class="mb-2">Edit Task</h3>
                  <input
                    v-model="editTaskText"
                    type="text"
                    class="border p-1 w-full"
                  />
                  <div class="flex justify-end mt-2">
                    <button
                      @click="updateTask"
                      class="bg-blue-500 text-white px-2 py-1 rounded mr-2"
                    >
                      Update
                    </button>
                    <button
                      @click="isEditing = false"
                      class="bg-gray-500 text-white px-2 py-1 rounded"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div> -->
              <div
                v-if="isEditing"
                class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
              >
                <div
                  class="w-[90%] lg:w-[40%] bg-white rounded-xl p-6 lg:p-10 overflow-y-auto max-h-[600px]"
                >
                  <div class="flex items-center justify-center">
                    <h3 class="lg font-bold text-textblues text-center">
                      Edit Task
                    </h3>
                  </div>

                  <div
                    class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
                  >
                    <div class="w-full">
                      <form
                        ref="createTeamRef"
                        @submit.prevent="updateTask()"
                        class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                      >
                        <div>
                          <textarea
                            v-model="editTaskText"
                            name=""
                            id=""
                            cols="30"
                            rows="5"
                            class="border p-1 w-full"
                          ></textarea>
                        </div>

                        <div class="flex justify-center pb-4 mt-3 gap-10">
                          <button
                            @click="isEditing = false"
                            class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                          >
                            Close
                          </button>
                          <div class="flex justify-end items-center gap-3">
                            <button
                              type="submit"
                              :disabled="disable_submit == true"
                              :class="
                                this.disable_submit == true
                                  ? 'bg-gray-200 text-black cursor-not-allowed'
                                  : 'bg-blues hover:bg-hover cursor-pointer text-white'
                              "
                              class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                            >
                              Update
                            </button>
                            <img
                              v-if="disable_submit"
                              src="@/assets/loading.gif"
                              alt="loading"
                              class="w-6 h-6 object-contain"
                            />
                          </div>
                          <!-- <button
                            class="border text-white rounded-lg bg-blues text-sm px-5 lg:px-10 font-semibold py-2"
                          >
                            Update
                          </button> -->
                        </div>

                        <div
                          v-if="editmessages"
                          class="text-green-400 text-lg font-bold"
                        >
                          {{ editmessages }}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="" v-for="todo in [0, 1, 2, 3]" :key="todo">
                <div
                  class="flex justify-center gap-4 bg-[#105C8E1A] p-4 rounded-lg items-center"
                >
                  <img
                    src="@/assets/Vector(11).png"
                    alt=""
                    srcset=""
                    class="object contain w-4 h-4 mt-1"
                  />
                  <div class="flex flex-col gap-1">
                    <p class="text-sm font-bold text-[#333333] text-wrap">
                      15 Assignments Due
                    </p>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <!-- Announcements -->
          <div class="flex flex-col gap-3 md:min-w-[330px]">
            <div
              class="bg-[#EDF8FF] flex justify-between py-2 px-3 rounded-xl items-center"
            >
              <h1 class="text-[#0085DB] lg font-semibold">Announcements</h1>
              <router-link
                :to="{ name: 'StudentNotifications' }"
                v-if="this.notificationList.length > 3"
              >
                <img
                  src="@/assets/chevron-down.png"
                  alt=""
                  srcset=""
                  class="object-contain w-5 h-5"
                />
              </router-link>
            </div>
            <div class="p-6 w-full h-[330px]">
              <div
                v-if="notificationList.length > 0"
                class="flex flex-col gap-5 lg:justify-between"
              >
                <div
                  class="border-b pb-4 border-gray-300"
                  v-for="notifi in this.notificationList.slice(0, 3)"
                  :key="notifi"
                >
                  <div class="flex gap-4">
                    <img
                      src="@/assets/Group 610.png"
                      alt=""
                      srcset=""
                      class="object contain w-7 h-7 mt-1"
                    />
                    <div class="flex flex-col gap-1">
                      <h1
                        class="text-sm font-bold text-black w-[230px] text-wrap line-clamp-2"
                      >
                        {{ notifi.topic }}
                      </h1>
                      <div
                        v-if="notifi.is_student_enrollment"
                        class="text-xs text-gray-600 space-y-1"
                      >
                        <p>
                          <span class="font-semibold text-black">
                            Student Name :
                          </span>
                          {{ getEnrollmentData(notifi).student_name }}
                        </p>

                        <p>
                          <span class="font-semibold text-black">
                            Student Email :
                          </span>
                          {{ getEnrollmentData(notifi).student_email }}
                        </p>

                        <p>
                          <span class="font-semibold text-black">
                            Program :
                          </span>
                          {{ getEnrollmentData(notifi).program?.name }}
                        </p>

                        <p>
                          <span class="font-semibold text-black">
                            Batch :
                          </span>
                          {{ getEnrollmentData(notifi).batch?.name }}
                        </p>

                        <p>
                          <span class="font-semibold text-black">
                            Semester :
                          </span>
                          {{ getEnrollmentData(notifi).semester?.name }}
                        </p>
                      </div>

                      <!-- Normal Notification -->
                      <p
                        v-else
                        class="text-xs font-bold text-[#ADADAD] text-wrap line-clamp-2"
                      >
                        {{ notifi.message }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>No Announcement</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Admin/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";

import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import Calendar from "@/components/Calendar.vue";
import SearchView from "@/components/SearchView.vue";
export default {
  components: {
    Header,
    Footer,
    ConfirmPopup,
    FlashMessage,
    VueCal,
    Calendar,
    SearchView,
  },

  data() {
    return {
      logotitle: process.env.VUE_APP_TITLE,
      courselist: "",
      instructorInfo: "",
      messages: "",
      popupwindow: false,
      loading: true,
      searching: "",
      notificationList: [],
      todolist: [],
      newTask: "",
      isEditing: false,
      editTaskText: "",
      editTaskId: null,
      showButton: false,
      editmessages: "",
      success_message: "",
      success_delemessage: "",
      currentYear: "",
      currentMonth: "",
      currentDate: "",
      fullDate: "",
      disable_submit: false,
      submitted: [],
      submittedURL: [],
      openPopup: false,
      fileTitle: "",
      fileLink: "",
      messages: {
        text: "",
        type: "",
      },
      openEditPopupURL: false,
      editId: null,
      editTitle: "",
      editLink: "",
      showDeletePopup: false,
      deleteItemId: null,
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    await axios
      .get(
        `${process.env.VUE_APP_API}/instructor/?Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        this.instructorInfo = response.data;
      });
    await axios
      .get(
        `${process.env.VUE_APP_API}/courses/?instructor=${this.instructorInfo.id}&Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        this.courselist = response.data.data;
      });
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    setTimeout(() => {
      this.loading = false;
    }, 2000);
    this.getNotifications();
    this.getTodo();
    this.getSubmittedData();
    this.getSubmittedURL();
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    getEnrollmentData(notification) {
      try {
        if (!notification?.message) {
          return {};
        }

        if (typeof notification.message === "string") {
          return JSON.parse(notification.message);
        }

        return notification.message;
      } catch (error) {
        console.error("Failed to parse notification message:", error);

        return {};
      }
    },
    confirmDelete(slug) {
      this.deleteItemId = slug;
      this.showDeletePopup = true;
    },

    deleteURL() {
      axios
        .delete(
          `${process.env.VUE_APP_API}/course-external-links/${this.deleteItemId}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.showDeletePopup = false;
            this.getSubmittedURL();
            setTimeout(() => {
              this.messages = { text: "", type: "" };
            }, 2500);
          } else {
            this.messages = {
              text: response.data.message || "Something went wrong",
              type: "error",
            };
          }
        });
    },
    openEditModal(item) {
      this.editId = item.slug;
      this.editTitle = item.title;
      this.editLink = item.urllink;
      this.openEditPopupURL = true;
    },

    updateURL() {
      const bodyVal = {
        user: this.userInfo.user.id,
        title: this.editTitle,
        urllink: this.editLink,
      };

      axios
        .put(
          `${process.env.VUE_APP_API}/course-external-links/${this.editId}/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.openEditPopupURL = false;
            this.getSubmittedURL();
            setTimeout(() => {
              this.messages = { text: "", type: "" };
            }, 2500);
          } else {
            this.messages = {
              text: response.data.message || "Something went wrong",
              type: "error",
            };
          }
        });
    },

    getSubmittedURL() {
      axios
        .get(
          `${process.env.VUE_APP_API}/course-external-links/list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.submittedURL = res.data.data || [];
        });
    },
    addURL() {
      this.disable_submit = true;
      const bodyVal = {
        user: this.userInfo.user.id,
        title: this.fileTitle,
        urllink: this.fileLink,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/course-external-links/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.fileTitle = "";
            this.fileLink = "";
            this.openPopup = false;
            this.getSubmittedURL();
            setTimeout(() => {
              this.messages = { text: "", type: "" };
            }, 2500);
          } else {
            this.messages = {
              text: response.data.message || "Something went wrong",
              type: "error",
            };
          }
        })
        .catch(() => {
          this.messages = {
            text: "Server error. Please try again.",
            type: "error",
          };
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    getShortName(url) {
      if (!url) return "";
      const fileName = url.split("/").pop();
      return fileName.length > 20
        ? fileName.substring(0, 20) + "..."
        : fileName;
    },
    getSubmittedData() {
      axios
        .get(
          `${process.env.VUE_APP_API}/pdf-upload-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.submitted = res.data.data.data;
        });
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.showSuggestions = false;
      }
    },
    async deletecourse(data) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          this.res = response;
          if (this.res.statusText == "No Content") {
            this.messages = {
              text: "Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      this.popupwindow = false;

      setTimeout(() => {
        this.$router.go(0);
        this.messages = {
          text: "",
          type: "null",
        };
      }, 2000);
    },

    receiveCalEmit(data) {
      axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&date=${data}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
          }
        });

      axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&date=${data}`,
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
          }
        });
    },

    cleartask() {
      this.newTask = "";
      this.showButton = false;
    },

    async getNotifications() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&year=${this.currentYear}&month=${this.currentMonth}&date=${this.fullDate}`,
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
          }
        });
    },
    openEditPopup(task) {
      this.editTaskText = task.text;
      this.editTaskId = task.id;
      this.isEditing = true;
    },
    addTask() {
      this.disable_submit = true;
      if (this.newTask.trim()) {
        let bodyVal = {
          text: this.newTask,
          user: this.userInfo.user.id,
        };

        axios
          .post(
            `${process.env.VUE_APP_API}/to-do-create/?Key=${this.userInfo.token_key}`,
            bodyVal,
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.success_message = response.data.message;
              setTimeout(() => {
                this.success_message = "";
              }, 900);
              this.newTask = "";
              this.showButton = false;
              this.disable_submit = false;
              this.getTodo();
            } else {
              this.disable_submit = false;
            }
          })
          .finally(() => {
            this.loaders = false;
          });
      }
    },
    async getTodo() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&search=false`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
          }
        });
    },
    updateTask() {
      this.disable_submit = true;
      let formdata = {
        text: this.editTaskText,
      };

      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-text-edit/${this.editTaskId}/?Key=${this.userInfo.token_key}`,
          formdata,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.editmessages = response.data.message;

            setTimeout(() => {
              this.editmessages = "";
              this.isEditing = false;
              this.disable_submit = false;
              this.getTodo();
            }, 2000);
          } else {
            this.disable_submit = false;
          }
        })
        .finally(() => {
          this.loaders = false;
        });
    },
    deleteTask(id) {
      axios
        .delete(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.success_delemessage = response.data.message;
            setTimeout(() => {
              this.success_delemessage = "";
            }, 900);
            this.getTodo();
          }
        });
    },
    completeTask(id) {
      let completedata = {
        completed: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.userInfo.token_key}`,
          completedata,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.success_message = response.data.message;
            setTimeout(() => {
              this.success_message = "";
            }, 900);
            this.getTodo();
          }
        });
    },
  },
};
</script>

<style></style>
